import { MenuItemProcessingRule } from '../interfaces';

export const menuItemStockAvailabilityRule: MenuItemProcessingRule = context => ({
	...context,
	items: context.items.map(item => ({
		...item,
		stock: item.stock === null || item.stock === undefined
			? null
			: Math.floor(Number(item.stock)),
	})),
});
